<template>
  <g fill="#FFF">
    <path
      d="M6.27 18.9h.77V17h-.77a2.86 2.86 0 010-5.72h.57c.5 0 .91-.38.96-.87a5.04 5.04 0 015.02-4.48 5 5 0 015.04 4.64c.02.4.28.73.65.85a2.86 2.86 0 01-.89 5.58h-.77v1.92h.77a4.78 4.78 0 002.08-9.1 6.96 6.96 0 00-6.88-5.8 6.87 6.87 0 00-6.8 5.35 4.78 4.78 0 00.24 9.55z"
    />
    <path
      d="M12.9 13.45v3.84l.83-.78a.96.96 0 111.32 1.4l-2.45 2.3a.96.96 0 01-1.31 0l-2.45-2.3a.96.96 0 111.32-1.4l.82.78v-3.84a.96.96 0 111.92 0"
    />
  </g>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "ImportIcon",
});
</script>
